/* Demographic Verification Centre
   
   Houses the clinician/admin review queue for demographic_submission
   rows in pending_verification status (tenant-wide, staging-only scope
   per the design addendum — no clinician-assignment model exists yet).
*/
import React from "react";
import * as FiIcons from "react-icons/fi";
import DemographicVerificationQueue from "./DemographicVerificationQueue";
const { FiUserCheck } = FiIcons;

const DemographicVerificationCenter = () => {
  return (
    <div className="min-h-screen text-slate-200">
      <div className="max-w-[1600px] mx-auto p-4 lg:p-6">
        <header className="flex justify-between items-center mb-6 lg:mb-8">
          <div>
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-black tracking-tight flex items-center gap-3">
              <FiUserCheck className="text-primary-500" />
              DEMOGRAPHIC VERIFICATION
            </h1>
            <div className="flex items-center gap-2 mt-1">
              <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
              <span className="text-xs text-slate-400 font-bold uppercase tracking-widest">
                Tenant-wide queue — staging scope, pending assignment model
              </span>
            </div>
          </div>
        </header>

        <DemographicVerificationQueue />
      </div>
    </div>
  );
};

export default DemographicVerificationCenter;
